import { render, staticRenderFns } from "./covidQuestions2.vue?vue&type=template&id=3aeabd52&"
import script from "./covidQuestions2.vue?vue&type=script&lang=js&"
export * from "./covidQuestions2.vue?vue&type=script&lang=js&"
import style0 from "./covidQuestions2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports